<!--
일괄기능-전체 아이템 선택기
------------------------------------

-->
<template>
    <input class="uk-checkbox" type="checkbox" v-on:change="setAllChecked($event)" :checked="isAllChecked"/>
</template>

<script>
    export default {
        props: {
            /**
             * 아이템배열 (상세정의는 컨트롤러 참고)
             */
            items: Array
        },
        data: function () {
            return {
            };
        },
        computed: {
            // 모든 아이템이 선택되었는지 여부
            isAllChecked() {
                return _.every(this.items, ['checked', true]);
            }
        },
        methods: {
            // 모든 아이템을 이벤트가 발생한 체크박스의 상태대로 변경
            setAllChecked(event) {
                let checked = event.srcElement.checked;
                 _.forEach(this.items, item => {
                    item.checked = checked;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>